import image1 from '../Images/ScrollerImages/image1.webp'
import image2 from '../Images/ScrollerImages/image2.webp'
import image3 from '../Images/ScrollerImages/image3.webp'
import image4 from '../Images/ScrollerImages/image4.webp'
import image5 from '../Images/ScrollerImages/image5.webp'
import image6 from '../Images/ScrollerImages/image6.webp'
import image7 from '../Images/ScrollerImages/image7.webp'
import image8 from '../Images/ScrollerImages/image8.webp'
import image9 from '../Images/ScrollerImages/image9.webp'

export const shoes = [
    {
        img: image1,
        title: 'Jordan 4 Red Cement',
    },
    {
        img: image2,
        title: "Jordan 4Frozen Moments",
    },
    {
        img: image3,
        title: 'Jordan 1 Spider-Man',
    },
    {
        img: image4,
        title: 'Jordan Mid French Blue',
    },
    {
        img: image5,
        title: 'Dunk Low University Red',
    },
    {
        img: image6,
        title: 'Dunk Low Grey Fog',
    },
    {
        img: image7,
        title: 'Dunk Low Next Nature White Mint',
    },
    {
        img: image8,
        title: 'Original Campus 00s Black',
    },
    {
        img: image9,
        title: 'Original Campus 00s Gray',
    },
];

export function paginateArray(array, itemsPerPage) {
    const paginatedArray = [];
    let pageIndex = 0;

    while (pageIndex < array.length) {
        paginatedArray.push(array.slice(pageIndex, pageIndex + itemsPerPage));
        pageIndex += itemsPerPage;
    }
    
    return paginatedArray;
}
  